/**
 * Generated by orval v7.16.0 🍺
 * Do not edit manually.
 * 救急隊ポータルApp
 * OpenAPI spec version: 0.1.0
 */

/**
 * 血圧測定部位
 */
export type VitalBpPartEnum =
  (typeof VitalBpPartEnum)[keyof typeof VitalBpPartEnum];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const VitalBpPartEnum = {
  RADIAL: 'RADIAL',
  FEMORAL: 'FEMORAL',
  COMMON_CAROTID: 'COMMON_CAROTID',
} as const;
